// extracted by mini-css-extract-plugin
export var icon = "_bh-3";
export var subtitle = "_bh-2";
export var title = "_bh-1";
export var value = "_bh-0";